import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import PageLoader from '../../components/PageLoader/PageLoader';
import { useUnifiedDispatchTaskTypes } from '../../pages/dispatch/utils/use-unified-dispatch-task-types';
import type { RouterOutletContext } from '../router';

/**
 * Holds `/dispatch` behind the same gate as the nav links and the legacy route redirects, so the rollout flag
 * decides who reaches the unified view rather than only who gets linked to it — without this, an entitled hauler
 * could type the URL and land on the new page while the rollout says they belong on the legacy ones.
 *
 * Deliberately not inside `WaysteStandardWrapper`: a waysteLite hauler served portable toilet dispatch passes this
 * gate and that wrapper would block them, the same way the standalone portable toilet routes let them through.
 */
const UnifiedDispatchGuard = () => {
    const context = useOutletContext<RouterOutletContext>();
    const unifiedDispatchTaskTypes = useUnifiedDispatchTaskTypes();

    // Hold the route until the flag resolves rather than 404ing a hauler who turns out to be opted in.
    if (unifiedDispatchTaskTypes === null) {
        return <PageLoader />;
    }

    // Nothing to serve — either the rollout hasn't reached this hauler or they're entitled to no task type.
    if (unifiedDispatchTaskTypes.length === 0) {
        return <Navigate to="/404" replace />;
    }

    return <Outlet context={context} />;
};

export default UnifiedDispatchGuard;
